import clsx from "clsx";
import { BWOther, ColorOther } from "@assets/illustrations";
import { USER_ROLES } from "@utils/consts";
import { useState } from "react";
import Loader from "@components/Loader";
import { useMatch } from "react-router-dom";
import { MESSAGES } from "@router/consts";

const ProfilePictureItem = ({
  profile,
  profilePictureUrl,
  alt,
  size,
  isGroupChat,
  isResponsiveSize,
}) => {
  const [imgError, setImgError] = useState(false);
  const [isImgLoading, setIsImgLoading] = useState(true);
  const isEligibleRouteToApplyAnonymousPicture = !!useMatch(MESSAGES);

  const illustrationProps = isResponsiveSize
    ? { width: "100%", height: "100%", className: "w-full h-full" }
    : {
        width: size,
        height: size,
        className: `min-w-[${size}px] min-h-[${size}px] max-w-[${size}px] max-h-[${size}px]`,
      };

  if (isGroupChat) {
    return <ColorOther {...illustrationProps} />;
  }

  if (profile?.isAnonymous && isEligibleRouteToApplyAnonymousPicture) {
    return <BWOther {...illustrationProps} />;
  }

  const handleProfileIllustration = () => {
    return <ColorOther {...illustrationProps} />;
  };

  if (!profilePictureUrl) {
    return handleProfileIllustration();
  }

  return !imgError ? (
    <>
      <img
        className={clsx(
          "rounded-full disabled object-cover w-full h-full",
          !isResponsiveSize &&
            `min-w-[${size}px] min-h-[${size}px] max-w-[${size}px] max-h-[${size}px]`,
          isImgLoading ? "opacity-0" : "",
        )}
        src={profilePictureUrl}
        onError={() => setImgError(true)}
        onLoad={() => setIsImgLoading(false)}
        alt={alt}
        width={isResponsiveSize ? undefined : size}
        height={isResponsiveSize ? undefined : size}
      />
      {isImgLoading && (
        <div className="absolute flex w-full h-full top-0 left-0 items-center justify-center">
          <Loader height={25} width={25} />
        </div>
      )}
    </>
  ) : (
    handleProfileIllustration()
  );
};

const ProfilePicture = ({
  profile,
  profilePictureUrl,
  size = 50,
  sizeClassName,
  statusSize = 10,
  isShowOnline = false,
  alt,
  isGroupChat,
  className = "",
}) => {
  const isResponsiveSize = !!sizeClassName;
  return (
    <div
      className={clsx(
        "inline-block mr-3 shrink-0",
        isResponsiveSize && sizeClassName,
        className,
      )}
      style={
        isResponsiveSize
          ? { position: "relative", overflow: "visible" }
          : {
              width: `${size}px`,
              height: `${size}px`,
              position: "relative",
              overflow: "visible",
            }
      }
    >
      <ProfilePictureItem
        profile={profile}
        profilePictureUrl={profilePictureUrl}
        alt={alt}
        isGroupChat={isGroupChat || false}
        size={size}
        isResponsiveSize={isResponsiveSize}
        className={className}
      />
      {isShowOnline && profile?.type === USER_ROLES.COUNSELLOR_ROLE && (
        <span
          style={{
            position: "absolute",
            bottom: "10%",
            right: "20%",
            width: `${statusSize}px`,
            height: `${statusSize}px`,
            borderRadius: "50%",
            border: "2px solid white",
            background: profile.isOnline ? "#1fc47c" : "#78716c",
            zIndex: 2,
            boxSizing: "content-box",
            pointerEvents: "none",
            display: "block",
            transform: "translate(50%, 50%)",
          }}
        />
      )}
    </div>
  );
};

export default ProfilePicture;
